import React from "react";
import { UserLogin } from "../../types";
import {
  isToday,
  format,
  isYesterday,
  isThisWeek,
  isThisMonth,
} from "date-fns";
import { Link, useParams } from "react-router-dom";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { MdInsertPhoto } from "react-icons/md";
import { LuSearch } from "react-icons/lu";
import { TiDocumentText } from "react-icons/ti";

type ChatSideBarProps = {
  filteredFriends?: UserLogin[];
  userID: string | null;
  pickRandomColor?: (userId: string) => string;
  myColor?: string;
  setFilterText: React.Dispatch<React.SetStateAction<string>>;
  markAsRead?: () => Promise<void>;
};
const ChatSideBar: React.FC<ChatSideBarProps> = ({
  filteredFriends,
  userID,
  myColor,
  setFilterText,
  pickRandomColor,
  markAsRead,
}) => {
  const { id } = useParams<{ id: string }>();
  // console.log(profileDetails, "profileDetails");

  // console.log(notification);
  const message = "Sent a Photo";
  const fileMessage = "Sent a File";
  return (
    <div className="lg:border-r flex flex-col lg:border-solid lg:border-[#0000000D] px-3 lg:px-0 top-0 left-0 pt-9 w-full lg:w-[265px]">
      {filteredFriends && filteredFriends?.length > 0 && (
        <div className="flex justify-between px-3 items-center h-[66px]">
          {/* <div className="flex">
            <RxHamburgerMenu size={24} className="text-[#2E3A59]" />
          </div> */}
          <div className="w-full relative">
            <input
              type="text"
              className="h-8 outline-none placeholder:font-SegoeUI placeholder:text-[#0000009B] placeholder:text-sm placeholder:font-normal w-full px-3 pr-5 bg-[#F6F7F9] rounded-md"
              placeholder="Search"
              onChange={(e) => {
                setFilterText(e.target.value);
              }}
            />
            <div className="absolute w-4 right-1 top-2">
              <LuSearch size={15} className="text-[#33363F]" />
            </div>
          </div>
          {/* <div className="flex">
            <RiEditBoxLine size={22} className="text-[#2E3A59]" />
          </div> */}
        </div>
      )}
      <div
        className="relative overflow-y-auto h-[calc(100%-66px)] j"
        // onClick={markAsRead}
      >
        {filteredFriends &&
          filteredFriends?.map((friend, index) => {
            const bgColor =
              pickRandomColor && pickRandomColor(friend.receiverID);
            // console.log(bgColor, "bg");

            const date = friend?.lastMessageTime
              ? new Date(
                  (friend.lastMessageTime.seconds ?? 0) * 1000 +
                    (friend.lastMessageTime.nanoseconds ?? 0) / 1e6
                )
              : new Date();

            let formattedDate;

            if (isToday(date)) {
              formattedDate = format(date, "h:mm a");
            } else if (isYesterday(date)) {
              formattedDate = "Yesterday";
            } else if (isThisWeek(date)) {
              formattedDate = format(date, "iiii"); // Display the day name (Monday, Tuesday, etc.)
            } else if (isThisMonth(date)) {
              formattedDate = format(date, "d MMMM"); // Display date with month (e.g., 5 February)
            } else {
              formattedDate = format(date, "d MMMM yyyy");
            }
            // console.log(friend?.lastMessage.length);

            const notification =
              friend?.unreadMessages && friend?.unreadMessages;
            return (
              <Link
                to={`/chat/e/${friend?.chatId}`}
                onClick={markAsRead}
                key={friend.id}
              >
                <div
                  className={`relative w-full flex items-center py-3 pl-3 pr-1 border-b border-solid border-[rgba(0,0,0,0.06)] cursor-pointer hover:bg-[#EBEBEB] ${
                    friend?.chatId === id && "bg-[#EDF4F6]"
                  }`}
                >
                  {friend?.profileImage &&
                  friend.profileImage !== undefined &&
                  friend.profileImage !== null ? (
                    <div className="relative h-8 min-w-[32px] overflow-hidden rounded-full mr-[8px]">
                      <img
                        src={ipfsGatewayImage(friend.profileImage!)}
                        alt=""
                        className="h-8 w-8 rounded-full"
                      />
                    </div>
                  ) : (
                    (bgColor || myColor) && (
                      <div
                        className="h-8 w-8 shadow font-SegoeUI font-normal text-[18px] mr-[8px] text-[#FFF] capitalize rounded-full flex items-center justify-center"
                        style={{ background: bgColor || myColor }}
                      >
                        <p className="h-8 w-8 rounded-full flex items-center justify-center">
                          {friend?.userName[0][0]}
                        </p>
                      </div>
                    )
                  )}
                  <div className="relative w-full font-SegoeUI font-normal items-center">
                    <div className="flex justify-between items-center mb-1">
                      <h4
                        className={`text-[#000000E4] text-sm ${
                          friend?.chatId === id && "font-medium"
                        }`}
                      >
                        {friend?.userName}
                      </h4>
                      <p className="text-[10px] text-[#0000009B] mt-[5px]">
                        {formattedDate}
                      </p>
                    </div>
                    <div className="flex justify-between w-full items-center ">
                      <div className="flex gap-1 text-xs items-center">
                        {friend?.lastMessage === message && <MdInsertPhoto />}
                        {friend.lastMessage === fileMessage && (
                          <TiDocumentText size={15} />
                        )}
                        <p className="text-[#0000009B] details">
                          {friend?.lastMessage}
                        </p>
                      </div>
                      {notification > 0 ? (
                        <b className=" bg-lightGreen text-[#fff] min-w-[16px] h-4 rounded-full flex justify-center font-Poppins items-center text-[8px]">
                          {notification}
                        </b>
                      ) : null}
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
      </div>
    </div>
  );
};

export default ChatSideBar;
